<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';

import { useDisplayWidths } from '#public_ts/composables';

interface JivoApi {
    open(): void;
    close(): void;
}

interface JivoConfig {
    chat_mode: string;
}

interface WindowWithJivo extends Window {
    jivo_api?: JivoApi;
    jivo_config?: JivoConfig;
    jivo_onLoadCallback?: () => void;
    jivo_onOpen?: () => void;
    jivo_onClose?: () => void;
    attachEvent?: (event: string, handler: () => void) => void;
}

const props = withDefaults(defineProps<{
    widgetId?: string;
}>(), {
    widgetId: 'VoKVyfPcmn',
});

const win = window as unknown as WindowWithJivo;

let scriptEl: HTMLScriptElement | null = null;
let loadHandler: (() => void) | null = null;
const DISPLAY_WIDTHS = useDisplayWidths();

function open() {
    win.jivo_api?.open();
}

function loadScript() {
    scriptEl = document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.async = true;
    scriptEl.src = `//code.jivosite.com/script/widget/${props.widgetId}`;
    document.head.appendChild(scriptEl);
}

function setupCallbacks() {
    if(!DISPLAY_WIDTHS.isUserAgentMobile) {
        let jivo_cstm_widget: HTMLDivElement | undefined;
        win.jivo_onLoadCallback = function() {
            jivo_cstm_widget = document.createElement('div');
            jivo_cstm_widget.setAttribute('id', 'jivo_custom_widget');
            document.body.appendChild(jivo_cstm_widget);

            jivo_cstm_widget.onclick = function() {
                win.jivo_api?.open();
            };

            if(win.jivo_config?.chat_mode === 'online') {
                jivo_cstm_widget.setAttribute('class', 'jivo_online');
            }

            jivo_cstm_widget.style.display = 'none';
        };

        win.jivo_onOpen = function() {
            if(jivo_cstm_widget) {
                jivo_cstm_widget.style.display = 'none';
            }
        };

        win.jivo_onClose = function() {
            if(jivo_cstm_widget) {
                jivo_cstm_widget.style.display = 'block';
            }
        };
    } else {
        win.jivo_onLoadCallback = function() {
            const link = document.getElementById('jivo_custom_link');
            const mobile = document.getElementById('chat_mobile');
            if(link) link.style.display = 'none';
            if(mobile) mobile.style.display = 'none';
        };

        win.jivo_onClose = function() {
            const widget = document.getElementById('jivo_custom_widget');
            if(widget) widget.style.display = 'none';
        };

        win.jivo_onClose = function() {
            const widget = document.getElementById('jivo_custom_widget');
            if(widget) widget.style.display = 'block';
        };
    }
}

defineExpose({ open });

onMounted(() => {
    setupCallbacks();

    if(document.readyState === 'complete') {
        loadScript();
    } else {
        loadHandler = loadScript;
        if(win.attachEvent) {
            win.attachEvent('onload', loadHandler);
        } else {
            window.addEventListener('load', loadHandler, false);
        }
    }
});

onBeforeUnmount(() => {
    if(loadHandler) {
        window.removeEventListener('load', loadHandler, false);
        loadHandler = null;
    }
    if(scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
    }
});
</script>

<template>
    <div v-once id="chat_mobile" class="chat-mobile" @click="open">
        <i class="bi bi-chat-dots" aria-hidden="true" />
    </div>

    <div v-once id="jivo_custom_link">
        <a href="#" class="highlight-link font-weight-normal" @click.prevent="open">
            <i class="bi bi-chat-dots mr-2" aria-hidden="true" />Possiamo aiutarti?
        </a>
    </div>
</template>
